import React from "react";

/**
 * Link capture line-art icon — Lucide "link" stroke glyph.
 * Used on Capture list thumbs only; same purple stroke as other thumb glyphs.
 */
const LinkLineArt = ({
  color = "#8F38EF",
  width = 24,
  height = 24,
  strokeWidth = 2,
  style,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={{ width, height, flexShrink: 0, ...style }}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-link"
    aria-hidden="true"
    {...rest}
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

export default LinkLineArt;
